"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const simplebar_react_1 = __importDefault(require("simplebar-react"));
const ScrollAreaWrapper_1 = __importDefault(require("./ScrollAreaWrapper"));
/**
 * Scroll Area - extended and styled
 * [SimpleBar](https://github.com/Grsmto/simplebar)
 *
 * Note: "SimpleBar can't be used on the `<body>`, `<textarea>` or `<iframe>` elements."
 */
const ScrollArea = (_a) => {
    var { background, children, fade = false } = _a, rest = __rest(_a, ["background", "children", "fade"]);
    return (react_1.default.createElement(ScrollAreaWrapper_1.default, { background: background, fade: fade },
        react_1.default.createElement(simplebar_react_1.default, Object.assign({ scrollableNodeProps: { tabIndex: 0 } }, rest), children)));
};
exports.default = ScrollArea;
//# sourceMappingURL=ScrollArea.js.map